import type { ProductConfigurableGtm } from '~/types/ProductConfigurableGtm'
import type { ProductBase } from '~/types/productBase'

export function getGtmProductUrl(product: ProductBase | ProductConfigurableGtm) {
    return product.url.startsWith('/p/') ? product.url : `/p/${product.url}`
}
